import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';

import { SharedModule } from '@app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

import { ChangeStepService } from '@app/core/components/stepper/service/change-step.service';
import { ChangeDeviceService } from '@app/shared/services/change-device.service';
import { SaveDataService } from '@app/shared/services/save-data.service';

import { SelectButtonOptionClickEvent } from 'primeng/selectbutton';
import { LabelCode } from '@app/shared/interfaces/label-code.interface';
import { CoreModule } from '@app/core/core.module';
import { AppService } from '@app/app.service';

@Component({
    selector: 'app-additional-data-loan',
    standalone: true,
    imports: [CoreModule, CommonModule, SharedModule, TranslateModule],
    templateUrl: './additional-data-loan.component.html',
    styleUrl: './additional-data-loan.component.scss',
})
export class LoanComponent {
    continueButton = 'common.buttons.continueButton';
    backButton = 'common.buttons.backButton';

    additionalDataTitle = 'features.additionalData.additionalDataTitle';
    additionalDataSubtitle = 'features.additionalData.additionalDataSubtitle';

    loanHead = 'features.additionalData.loan.loanHead';
    monthlyCostLabel = 'features.additionalData.loan.monthlyCostLabel';
    monthlyCostInput = 'features.additionalData.loan.monthlyCostInput';

    backButtonDisabled = false;
    continueButtonDisabled = true;

    isPortraitDevice = false;

    formGroup!: FormGroup;

    loanSituationOptions: LabelCode[] = [];
    selectedStatusOptions!: LabelCode;
    showForm: boolean = false;
    yesSelected: boolean = false;

    private appData = inject(AppService);

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private changeDeviceService: ChangeDeviceService,
        private changeStepService: ChangeStepService,
        private saveDataService: SaveDataService,
        private fb: FormBuilder,
    ) {
        this.changeStepService.changeStep(12);
    }

    ngOnInit() {
        this.isPortraitDevice = this.changeDeviceService.isPortraitDevice;
        this.changeDeviceService.changedDevice.subscribe((value) => {
            this.isPortraitDevice = value;
        });

        this.createForm();
        this.setValuesForm(this.appData.data.userData.additionalDataLoan);
        this.formIsValid();
    }

    createForm() {
        this.loanSituationOptions = [
            { label: 'Si', code: 'S' },
            { label: 'No', code: 'N' },
        ];

        if (this.showForm) {
            console.log(this.yesSelected);
            if (this.yesSelected) {
                this.formGroup = this.fb.group({
                    loanSituation: new FormControl(this.selectedStatusOptions ? this.selectedStatusOptions.code : 'S'),
                    cost: new FormControl(null, [
                        Validators.required,
                        Validators.minLength(1),
                        Validators.min(0),
                        Validators.maxLength(15),
                        Validators.pattern(/^-?(0|[1-9]\d*)?$/),
                    ]),
                });
            } else {
                this.formGroup = this.fb.group({
                    loanSituation: new FormControl(this.selectedStatusOptions ? this.selectedStatusOptions.code : 'N'),
                });
            }
        } else {
            this.formGroup = this.fb.group({
                loanSituation: new FormControl(this.selectedStatusOptions ? this.selectedStatusOptions.code : '', [Validators.required]),
            });
        }
    }

	setValuesForm(value?: any) {
	    if (value != undefined) {
	        this.formGroup = this.fb.group({
	            loanSituation: new FormControl(value.loanSituation ? value.loanSituation : 'false'),
	            cost: new FormControl(value.cost ? value.cost : '', [Validators.required])
	        });
	        this.yesSelected = value.loanSituation;
	        if("S" === value.loanSituation)
	            this.showForm = true;
	    }
	}

    //-------------------------//
    //-------ON CHANGE--------//
    //-------------------------//

    onChangeLoan(event: SelectButtonOptionClickEvent) {
        this.showForm = true;
        if (event != undefined) this.selectedStatusOptions = event.option;
        //console.log(this.selectedStatusOptions);
        if (this.selectedStatusOptions.code == 'S') {
            this.yesSelected = true;
        } else if (this.selectedStatusOptions.code == 'N') {
            this.yesSelected = false;
        }
        this.createForm();
        this.formIsValid();
    }

    onChangeCost(event: Event) {
        this.formIsValid();
    }

    //-------------------------//
    //-------VALIDATION--------//
    //-------------------------//

    formIsValid() {
        this.continueButtonDisabled = !this.formGroup.valid;
    }

    //-------------------------//
    //--------NAVIGATION-------//
    //-------------------------//

    onClicButtonBack() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'additional-data-loan');
        this.router.navigate(['/main/step/additional-data-second'], { relativeTo: this.route });
    }

    onClicButtonContinue() {
        this.saveDataService.saveDataLocal(this.formGroup.value, 'additional-data-loan');
        this.router.navigate(['/main/secure-financing'], { relativeTo: this.route });
    }

    ngOnDestroy() {}
}
